<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12">
        <div>
          <!-- <v-btn v-if=" selected.length > 1" text @click="deleteUser" color="red">Delete Users</v-btn> -->
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-card width="500px" :loading="isLoading">
        <v-card-title>
          {{ $t('settings') }}
          <v-spacer></v-spacer>
<v-alert :type="licenseResult">
          {{ licenseResultCalculated }}
          </v-alert>          
        </v-card-title>

<v-form>
  <v-container>
          <v-row>
            <v-col>
            <v-text-field
            v-model="licenseKey"
            :label="$t('license_key')"
            required
            ></v-text-field>
          </v-col>
          </v-row>

          <v-row>
            <v-col>

              <v-btn color="primary" @click="updateLicenseKey">{{$t('save')}}</v-btn>
        
            </v-col>

          </v-row>


  </v-container>
          </v-form>

      </v-card>
    </v-row>
  </v-container>
</template>

<script>
// const API_URL = "http://localhost:9090/";

export default {
  name: "HelloWorld",
  data: () => ({
    token: "",
    licenseKey: "",
    licenseResult: "info",
    isLoading: true,
  }),

  computed: {
    licenseResultCalculated(){
      return this.$t('license_'+this.licenseResult)
    },

    formTitle() {
      return this.editedIndex === -1 ? "New User" : "Edit User";
    },
     
  },

  // created () {
  //     this.initialize()
  //   },

  mounted: function() {
    if(localStorage.token){
      this.token = localStorage.token
      this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.token}` 
    }
    this.fetchLicenseKey();
  },
  methods: {
   
    
    fetchLicenseKey: function() {
      this.$http.get(this.$API_URL + "get_license_key").then(result => {
        this.licenseKey = result.data[0].license_key
        this.checkLicenseKey()
      });
    }, 
    
    checkLicenseKey: function() {
      this.$http.get(this.$DEVELOPER_URL + "checklic.php?key="+this.licenseKey ).then(result => {
        this.licenseResult = result.data
        this.isLoading = false;
      });
    },
 
    updateLicenseKey: function() {
      this.isLoading = true;
      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + "update_license_key",
        data: { key: this.licenseKey }
      })
        .then(response => {
          // console.log(response.data);
          if (response.data == "1")
            this.checkLicenseKey()
            
          // if (response.data == "1")
          //  window.history.go(-1)
        })
        .catch(function(error) {
          console.log(error);
          this.isLoading =false;
        });
    }
  }
};
</script>
